import {
    CashbackRequestsCheckedPaginated,
    GetPaginatedData
} from "../../../../models/dashboard/marketplace/marketplaceCashbackRequestModel";
import {adminHttpClient} from "../../../../commons/adminHttpClinet";

const getRejectedCashbackRequest = (model: GetPaginatedData): Promise<CashbackRequestsCheckedPaginated> => {
    return adminHttpClient.get(`/api/Admin/AdminMarketplacePurchase/get-rejected-cashback-requests?skip=${model.pageNumber}&take=${model.pageSize}`)
}
export  default  getRejectedCashbackRequest;